import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  // localize,
} from 'vee-validate'
import {
  email,
  max,
  min,
  numeric,
  required,
  digits,
} from 'vee-validate/dist/rules'
// import ja from 'vee-validate/dist/locale/ja'

extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('required', required)
extend('digits', digits)

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

// localize('ja', ja)
// 日本語ローカライズの導入の参考情報
// https://qiita.com/sendaiharu1/items/b8a9fc03ff3e6de522a4
